import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Header,
  SectionTitle,
  ItemTitle,
  Intro,
} from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        inProgress="true"
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            Progress and loading let a user know the level of completion of a
            task or process. Visual indicators are used when background
            operations are underway to provide wayfinding for a user as they
            progress through a multi-step process. Using indicators well has a
            positive impact on the perceived speed of an experience as they make
            the user focus on progress rather than on wait-time. The type of
            indicator you use will be dependent on what the user is waiting for.
            Follow these guidelines to determine which type of indicator is
            needed.
          </p>
        </Intro>
        <SectionTitle>Types of Indicators</SectionTitle>
        <h3>For user-controlled actions:</h3>
        <p>
          To give the user an idea of how much of a task they have completed,
          use a user-controlled indicator such as the{' '}
          <Link
            class="link"
            to={'/' + data.site + '/components/progress-tracker/develop'}
          >
            progress tracker
          </Link>{' '}
          component. The highlighted steps show linear progress that updates in
          response to the user input or actions.
        </p>
        <div class="l-flex-row">
          <div class="l-flex-col--xs-6 u-pull--center">
            <div class="progress-tracker">
              <ul>
                <li class="progress-tracker--complete"></li>
                <li class="progress-tracker--complete"></li>
                <li class="progress-tracker--active">3</li>
                <li class="progress-tracker--default">4</li>
                <li class="progress-tracker--default">5</li>
              </ul>
            </div>
          </div>
        </div>

        <h3 class="l-margin-top--xxlarge">For system-controlled actions:</h3>
        <p>
          When a user initiates a task that requires a back-end call, use one of
          the below system-controlled indicators.
        </p>

        {/* <ItemTitle>Skeleton Loader</ItemTitle>
        <p>
          Skeleton loaders are a sophisticated wait animation that give the user
          an abstract idea of the content they are about to see. use skeleton
          loaders when loading new information in a layout and only when the
          format of the information is known beforehand. If the shape of the
          loader is vastly different from the loaded content, it will cause a
          jarring experience for the user. Do not use skeleton loaders for
          asynchronous or regional loading.
        </p> */}
        <ItemTitle>Spinner</ItemTitle>
        <p>
          Use a spinner when loading information whose layout is unknown. Use
          the variant that allows for copy to let the user know the system's
          exact status or give insight into what they're waiting for.{' '}
        </p>

        <ItemTitle>Ellipsis</ItemTitle>
        <p>
          Use this wait animation only in button loading states or to indicate
          communication in a chat window. Show the loading state of a button
          when the layout will not change to accommodate the new content but
          there is a significant wait for a back-end call (e.g. when submitting
          information in a form) or when new content follows the same pattern as
          previous content (e.g. loading more search results).
        </p>
        <div class="l-flex-row l-flex-center--xs">
          <button class="c-button--primary-loading l-margin-bottom--small l-flex-col--xs-4">
            <span class="c-button--primary-loading__item-1" />
            <span class="c-button--primary-loading__item-2" />
            <span class="c-button--primary-loading__item-3" />
          </button>
        </div>
        <p class="l-margin-top--xxlarge">
          When choosing which loading indicator to use, consider whether the
          layout will change, if the new layout is known or unknown and if you
          need to communicate the specific action with the user.
        </p>
        <hr />
        <SectionTitle>Determinate and Indeterminate Loading</SectionTitle>
        <p>
          Determinate loaders animate based on how long it will take to complete
          a task. Indeterminate loaders animate cyclically to let a user know
          that a task is underway, but give no indication of when the task may
          be completed. When possible, use determinate loaders, especially for
          longer tasks. Using indeterminate loaders for long periods can lead
          users to believe that something has gone wrong.
        </p>
      </Layout>
    </>
  )
}
